import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import {
    initializeAppCheck,
    ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import EnvUtil from "../utils/EnvUtil";
import { CONFIG } from "./ConfigFile";
import { getAuth } from "firebase/auth";

const env = EnvUtil.getEnv(window.location.href);

// Initialize Firebase
export const app = initializeApp(CONFIG[env]);
export const appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(
        env !== "prod"
            ? "6LfNnXsrAAAAALj5ys4lhR5LF92EwYW43teE7KTU"
            : "6LeGwHsrAAAAAJdyvlP7iVh4IDq2MaCL8m2GOnzd"
    ),
    isTokenAutoRefreshEnabled: true,
});

export const functions = getFunctions(app, "europe-west2");
export const analytics = getAnalytics(app);
export const firestore = getFirestore(app);
export const auth = getAuth(app);
analytics.app.automaticDataCollectionEnabled = true;

if (process.env.REACT_APP_FIREBASE_EMULATOR) {
    connectFunctionsEmulator(functions, "localhost", 5001);
}
